/* Andrea: keep the native, gateway-bound purchase button inside its original form. */
(() => {
  if (customElements.get('andrea-mobile-pdp')) return;
  customElements.define('andrea-mobile-pdp', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized || this.dataset.stickyBuy !== 'true') return;
      this.root = document.getElementById('shopify-section-' + this.dataset.sectionId);
      this.container = this.root && this.root.querySelector('.product-form__payment-container');
      if (!this.container || !this.container.querySelector('.product-form__add-button')) return;
      this.initialized = true;
      this.mobile = matchMedia('(max-width:760px)');
      this.buySlot = document.createElement('div');
      this.buySlot.className = 'as-native-buy-slot';
      this.container.before(this.buySlot);
      this.buySlot.append(this.container);
      this.spacer = document.createElement('div');
      this.spacer.setAttribute('aria-hidden', 'true');
      this.spacer.dataset.asMobileBuySpace = this.dataset.sectionId;
      document.body.append(this.spacer);
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.observe = new IntersectionObserver(this.schedule, {threshold: [0, 1]});
      this.observe.observe(this.buySlot);
      this.dialogObserver = new MutationObserver(this.schedule);
      this.dialogObserver.observe(document.body, {subtree:true, attributes:true, attributeFilter:['open','aria-hidden']});
      this.onPageShow = this.schedule;
      window.addEventListener('scroll', this.schedule, {passive:true});
      window.addEventListener('resize', this.schedule, {passive:true});
      window.addEventListener('pageshow', this.onPageShow);
      document.addEventListener('focusin', this.schedule);
      document.addEventListener('focusout', this.schedule);
      this.schedule();
    }
    update() {
      if (!this.container.isConnected) return;
      const active = document.activeElement;
      const editing = active && active.matches('textarea,select,input:not([type="radio"]):not([type="checkbox"]):not([type="hidden"]):not([type="button"]):not([type="submit"])');
      const modal = document.querySelector('dialog[open],[aria-modal="true"][aria-hidden="false"],.mobile-menu[aria-hidden="false"],#mini-cart[aria-hidden="false"],#sidebar-cart[aria-hidden="false"]');
      const shouldFix = this.mobile.matches && this.buySlot.getBoundingClientRect().bottom <= 0 && !modal && !editing;
      if (shouldFix !== this.fixed) {
        if (shouldFix) this.buySlot.style.height = this.buySlot.getBoundingClientRect().height + 'px';
        this.container.classList.toggle('as-native-buy-fixed', shouldFix);
        if (!shouldFix) this.buySlot.style.height = '';
        this.fixed = shouldFix;
      }
      this.spacer.style.height = shouldFix ? this.container.getBoundingClientRect().height + 'px' : '0px';
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      cancelAnimationFrame(this.frame);
      this.observe.disconnect();
      this.dialogObserver.disconnect();
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      window.removeEventListener('pageshow', this.onPageShow);
      document.removeEventListener('focusin', this.schedule);
      document.removeEventListener('focusout', this.schedule);
      this.container.classList.remove('as-native-buy-fixed');
      this.buySlot.before(this.container);
      this.buySlot.remove();
      this.spacer.remove();
      this.initialized = false;
    }
  });
})();
